import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_54: DocMigration = {
  maxSchemaVersion: "0.0.54",
  description: "Deduplicate room settings object",
  apply(json: any) {
    const uniqueRoomSettingsTables = {};
    for (const id in json.rooms) {
      const room = json.rooms[id];
      if (room.settingsOverride) {
        const existingSettingsOverride = room.settingsOverride;
        const newSettingsOverride = {};
        for (const key in existingSettingsOverride) {
          const existingSettingsUid = existingSettingsOverride[key];
          if (uniqueRoomSettingsTables[existingSettingsUid]) {
            const newSettingsUid = uid();
            newSettingsOverride[key] = newSettingsUid;
            json.settings[newSettingsUid] = json.settings[existingSettingsUid];
          } else {
            uniqueRoomSettingsTables[existingSettingsUid] = true;
            newSettingsOverride[key] = existingSettingsUid;
          }
        }
        room.settingsOverride = newSettingsOverride;
      }
    }
    return json;
  },
};

export default migration_0_0_54;
